



































import Vue, { PropType } from "vue";
import { mapActions, mapMutations } from "vuex";

export interface RetrieveLicenseProps {
  lang: any;
  supportUrl: string;
  volumeLicenseId: string;
  userId: string;
  locale: string;
}

export default Vue.extend({
  name: "vc-retrieve-license",
  props: {
    lang: {
      type: Object as PropType<RetrieveLicenseProps["lang"]>,
      default: () => {},
    },
    supportUrl: {
      type: String as PropType<RetrieveLicenseProps["supportUrl"]>,
      default: "",
    },
    volumeLicenseId: {
      type: String as PropType<RetrieveLicenseProps["volumeLicenseId"]>,
      default: "",
    },
    userId: {
      type: String as PropType<RetrieveLicenseProps["userId"]>,
      default: "",
    },
    locale: {
      type: String as PropType<RetrieveLicenseProps["locale"]>,
      default: "ja-jp",
    },
  },
  data() {
    return {
      showModal: false,
      isLoading: false,
    };
  },
  methods: {
    ...mapActions("common", [
      "createNotification",
      "createErrorNotification",
      "afterRedirectNotification",
    ]),
    ...mapActions("volumeLicenseUsers", ["deleteCollectLicense"]),
    ...mapMutations("volumeLicenseUsers", ["updateVolumeLicenseId"]),
    async retrieveLicense() {
      this.updateVolumeLicenseId(this.volumeLicenseId);
      this.isLoading = true;
      try {
        await this.deleteCollectLicense({ user_id: [this.userId] });
        this.afterRedirectNotification({
          label: this.lang.retrieve_success,
          style: "is-success",
        });
        location.href = `/${this.locale}/volume-licenses/${this.volumeLicenseId}/users/`;
      } catch {
        this.createErrorNotification({
          label: this.lang.retrieve_error_alert,
          style: "is-danger",
          linkLabel: this.lang.link_in_description,
          link: this.supportUrl,
        });
        this.isLoading = false;
        this.closeModal();
      }
    },
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
});
